const get_started = {
    page_title: 'شروع کار',
    title: 'چیزی برای کمک به موفقیت شما',
    subtitle: 'چند کاری که می‌توانید برای دریافت سریع ارزش از Logto انجام دهید',
    develop: {
        title: 'توسعه: ۵ دقیقه وقت بگذارید تا برنامه خود را یکپارچه کنید',
        title_cloud: 'توسعه: برنامه خود را در چند دقیقه به‌صورت امن یکپارچه کنید',
        subtitle_cloud: 'یا ۵ دقیقه وقت بگذارید تا برنامه خود را با SDK‌ها و آموزش‌های آماده ما یکپارچه کنید.',
        try_mcp: 'یکپارچه‌سازی با یک دستور را با MCP امتحان کنید',
    },
    customize: {
        title: 'شخصی‌سازی: تجربه ورود عالی ارائه دهید',
        preview: {
            title: 'پیش‌نمایش زنده تجربه ورودی که تازه شخصی‌سازی کردید را مشاهده کنید',
            subtitle: 'همین الان تجربه ورود Logto را امتحان کنید تا ببینید چگونه کار می‌کند',
        },
        connector: {
            title: 'اتصال‌دهنده‌های بیشتری برای پشتیبانی از روش‌های ورود اجتماعی بیشتر اضافه کنید',
            subtitle: 'ورود بدون رمز عبور را امتحان کنید و یک تجربه امن و بدون اصطکاک برای مشتریانتان فعال کنید',
        },
        continue_customizing: 'ادامه شخصی‌سازی',
        try_now: 'همین الان امتحان کنید',
        add_more: 'افزودن بیشتر',
    },
    secure: {
        title: 'امنیت: از منابع خود محافظت کنید',
    },
    manage: {
        title: 'مدیریت: کنترل دسترسی برای محصول و کاربران خود را تعریف کنید',
        rbac: {
            title: 'کنترل دسترسی مبتنی بر نقش را برای محافظت از منابع خود اضافه کنید',
            subtitle: 'منابع خود را از طریق مجوز نقش مقیاس‌پذیر برای موارد استفاده متنوع کنترل کنید.',
        },
        create_roles: 'ایجاد نقش‌ها',
    },
    convert_to_production: {
        card_title: 'آماده راه‌اندازی هستید؟ راه‌اندازی محیط تولید را فراموش نکنید!',
        title: 'پروژه خود را در حالت توسعه نگه ندارید',
        subtitle: 'شما از یک تنانت توسعه برای آزمایش رایگان استفاده می‌کنید. برای راه‌اندازی، یک تنانت تولیدی ایجاد کنید یا به آن تبدیل شوید. چیز سفارشی نیاز دارید؟ <a>با ما تماس بگیرید</a>',
        convert_button: 'تبدیل به تنانت تولیدی',
    },
    oss_cloud: {
        try: {
            title: 'از کارهای عملیاتی صرف نظر کنید — Logto Cloud را رایگان امتحان کنید',
            badge: 'توصیه شده',
            description: 'یک Logto کاملاً مدیریت‌شده با صفر نگهداری دریافت کنید — به‌علاوه یکپارچه‌سازی سریع مبتنی بر MCP، پشتیبانی از چند تنانت، همکاری تیمی، و تمام ویژگی‌های ممتاز. شروع رایگان، بدون نیاز به کارت اعتباری.',
            action: 'کاوش در Logto Cloud',
        },
        private_cloud: {
            title: 'به انطباق یا استقرار سفارشی نیاز دارید؟',
            card_title: 'ابر خصوصی',
            description: 'یک نمونه اختصاصی Logto با جداسازی کامل داده، دامنه سفارشی و تضمین SLA دریافت کنید. برای سازمان‌هایی با الزامات سخت‌گیرانه در مورد محل نگهداری داده یا انطباق ایده‌آل است. ما زیرساخت را مدیریت می‌کنیم تا شما بتوانید روی محصول خود تمرکز کنید.',
        },
        sidebar: {
            title: 'روی ساختن تمرکز کنید، نه میزبانی.',
            description: 'بگذارید Logto Cloud زیرساخت احراز هویت را برای شما مدیریت کند.',
            action: 'Logto Cloud را امتحان کنید',
        },
    },
    view_all: 'مشاهده همه →',
};
export default Object.freeze(get_started);
